import { render, staticRenderFns } from "./sc-modal.vue?vue&type=template&id=4ed7317f&scoped=true&"
import script from "./sc-modal.vue?vue&type=script&lang=js&"
export * from "./sc-modal.vue?vue&type=script&lang=js&"
import style0 from "./sc-modal.vue?vue&type=style&index=0&id=4ed7317f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7317f",
  null
  
)

export default component.exports